import React, { useState, useEffect, useRef } from "react";
import { keepSavedPricingIfUntouched, savedPricingNotice } from "./editPricingGuard";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import countryOptions from "../../components/List/Countries";
import { FormControlLabel } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Button from "@mui/material/Button";
import { useNavigate, useLocation } from "react-router-dom";
import CrudService from "services/cruds-service";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import "jspdf-autotable";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import { tr } from "date-fns/locale";
import { companies } from "../../companies";
import { extraCostOptions } from "constants/extraCosts";
import CreateCustomer from "../../crm/customer/CreateCustomer";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import CreateServiceProvider from "../../crm/Service Provider/CreateServiceProvider";
import { AddRowButton, RemoveRowButton } from "components/RowActions";
const RoadForm = ({ selectedTransportType, prefill }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [roadPricingMode, setRoadPricingMode] = useState("ALL_IN");

    const [exchangeRates, setExchangeRates] = useState(null);
    const [loadingRates, setLoadingRates] = useState(false);
    useEffect(() => {
        async function loadRates() {
            setLoadingRates(true);
            try {
                const res = await fetch("https://api.exchangerate-api.com/v4/latest/EUR");
                const data = await res.json();
                setExchangeRates(data.rates);
            } catch (err) {
                console.error("Error fetching exchange rates:", err);
            } finally {
                setLoadingRates(false);
            }
        }
        loadRates();
    }, []);

    const initialAddressState = {
        additionalInfo: "",
        country: "",
        city: "",
        officeCode: "",
        brokerageName: "",
        declarationNumber: "",
    };
    const incotermsOptions = [
        { label: "CFR" }, // Cost and Freight
        { label: "CIF" }, // Cost, Insurance and Freight
        { label: "CIP" }, // Carriage and Insurance Paid To
        { label: "CPT" }, // Carriage Paid To
        { label: "DAP" }, // Delivered at Place
        { label: "DAT" }, // Delivered at Terminal
        { label: "DPU" }, // Delivered at Place Unloaded
        { label: "DDP" }, // Delivered Duty Paid
        { label: "EXW" }, // Ex Works
        { label: "FAS" }, // Free Alongside Ship
        { label: "FCA" }, // Free Carrier
        { label: "FOB" }, // Free on Board
        { label: "FOT" }, // Free on Truck
        { label: "FOR" }, // Free on Rail
    ];
    const chargeTypeOptions = [
        { label: "Pre Carriage" },
        { label: "Road Freight Fee" },
    ];

    const statusOptions = [
        { value: "Pending", label: "Pending", color: "#FFB300" }, // amber
        { value: "Sent", label: "Sent", color: "#1E88E5" }, // blue
        { value: "Secured", label: "Secured", color: "#43A047" }, // green
        { value: "Lost", label: "Lost", color: "#E53935" }, // red
        { value: "Closed", label: "Closed", color: "#546E7A" }, // grey-blue
    ];
    const Dot = ({ color }) => (
        <span
            style={{
                display: "inline-block",
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: color || "#999",
                marginRight: 8,
                verticalAlign: "middle",
                flexShrink: 0,
            }}
        />
    );

    const serviceOptions = [
        { label: "Port to Port" },
        { label: "Port to Door" },
        { label: "Door to Port" },
        { label: "Door to Door" },
    ]
    const [inputValue, setInputValue] = useState("");
    const [open, setOpen] = useState(false);

    const imcoOptions = [
        { label: "(1.1) Substances and objects with a mass explosion hazard" },
        { label: "(1.2) Substances and objects with an explosion hazard but without a mass explosion hazard" },
        { label: "(1.3) Substances and objects with a fire hazard and a minor blast or minor projection hazard, or both, but without a mass explosion hazard" },
        { label: "(1.4) Substances and objects posing no significant hazard" },
        { label: "(1.6) Extremely insensitive substances without a mass explosion hazard" },
        { label: "(2.1) Flammable gases" },
        { label: "(2.2) Non-flammable, non-toxic gases" },
        { label: "(2.3) Toxic gases" },
        { label: "(3) Flammable liquids" },
        { label: "(4.1) Flammable solids, substances prone to spontaneous combustion, and solid desensitized explosives" },
        { label: "(4.2) Substances prone to spontaneous combustion" },
        { label: "(4.3) Substances emitting flammable gases when in contact with water" },
        { label: "(5.1) Oxidizing substances" },
        { label: "(5.2) Organic peroxides" },
        { label: "(6.1) Toxic substances" },
        { label: "(7) Radioactive substances" },
        { label: "(8) Corrosive substances" },
        { label: "(9) Miscellaneous dangerous substances and objects" },
    ];

    const [customerOptions, setCustomerOptions] = useState([]);
    const [partyOptions, setPartyOptions] = useState([]);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const [customersRes, agentsRes] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents(),
                ]);

                const customers = (customersRes.data || []).map((c) => ({
                    id: c.id,
                    name: c.attributes?.name || "Unnamed Customer",
                    type: "customer",
                }));

                const agents = (agentsRes.data || []).map((a) => ({
                    id: a.id,
                    name: a.attributes?.name || a.name || "Unnamed Global Agent",
                    type: "agent",
                }));

                const merged = [...customers, ...agents].sort((x, y) =>
                    (x.name || "").localeCompare(y.name || "")
                );

                setCustomerOptions(customers);  // ✅ EKLE
                setPartyOptions(merged);
            } catch (err) {
                console.error("Options alınırken hata oluştu:", err);
            } finally {
                setCustomersLoaded(true);
            }
        };

        fetchOptions();
    }, []);

    // companies (string[]) + partyOptions (object[]) => string[]
    const shipperConsigneeOptions = React.useMemo(() => {
        const companyItems = (companies || [])
            .map((name) => String(name || "").trim())
            .filter(Boolean)
            .map((name) => ({
                id: `company-${name.toLowerCase()}`,
                name,
                type: "company",
            }));

        const partyItems = (partyOptions || [])
            .filter((p) => p?.name)
            .map((p) => ({
                id: `${p.type}-${p.id}`,
                name: String(p.name).trim(),
                type: p.type, // "customer" | "agent"
            }));

        // unique by (type + name) (aynı isim farklı tipte olabilir)
        const map = new Map();
        [...companyItems, ...partyItems].forEach((item) => {
            const key = `${item.type}::${item.name.toLowerCase()}`;
            if (!map.has(key)) map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
    }, [partyOptions, companies]);

    const findOptionByName = (name) => {
        const target = String(name || "").trim().toLowerCase();

        if (!target) return null;

        return (
            shipperConsigneeOptions.find(
                (o) => String(o.name || "").trim().toLowerCase() === target
            ) || {
                id: `manual-${target}`,
                name,
                type: "manual",
            }
        );
    };
    const handleCustomerCreatedFromModal = (createdCustomer) => {
        const attr = createdCustomer?.attributes || createdCustomer;

        const newOption = {
            id: createdCustomer?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Customer",
            type: "customer",
        };

        setCustomerOptions((prev) => {
            const exists = prev.some(
                (x) => x.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        setPartyOptions((prev) => {
            const exists = prev.some(
                (x) =>
                    x.type === "customer" &&
                    x.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        if (customerModalTarget === "customer") {
            setSelectedCustomer(newOption);
            setInputValue(newOption.name);
        }

        if (customerModalTarget === "shipper") {
            setShipper(newOption.name);
        }

        if (customerModalTarget === "consignee") {
            setConsignee(newOption.name);
        }

        setCustomerModalOpen(false);
        setCustomerModalTarget(null);
    };

    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map(user => ({
                    id: user.id,
                    label: user.attributes.name
                }));

                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            } finally {
                setSalesRepsLoaded(true);
            }
        };
        fetchSalesReps();
    }, []);
    const [editSellingSnapshot, setEditSellingSnapshot] = useState(null);
    // { selling: number, currency: string, roadPricingMode: string, hasLineSelling: boolean }

    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const quotingToolId = searchParams.get("id");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const submittingRef = useRef(false); // çift tıklamada mükerrer kayıt oluşmasın
    const [customersLoaded, setCustomersLoaded] = useState(false);
    const [salesRepsLoaded, setSalesRepsLoaded] = useState(false);
    const [editDataLoaded, setEditDataLoaded] = useState(false);
    const editFetchStartedRef = useRef(false);
    const savedRecordRef = useRef(null); // düzenlenen kaydın DB'deki hali (fiyat koruması için)
    // Kayıttan sonraki yönlendirme: kullanıcı bu sürede sayfadan çıkarsa onu geri tabloya atmasın
    const redirectTimerRef = useRef(null);
    useEffect(() => () => clearTimeout(redirectTimerRef.current), []);
    const successMessageRef = useRef(null);
    const [carrierOptions, setCarrierOptions] = useState([]);
    const [manualSellingOverride, setManualSellingOverride] = useState(false);
    const [customerModalOpen, setCustomerModalOpen] = useState(false);
    const [customerModalTarget, setCustomerModalTarget] = useState(null);

    const NEW_PARTY_OPTION = {
        id: "new-party",
        name: "+ New Account",
        type: "new",
    };

    const [serviceProviderModalOpen, setServiceProviderModalOpen] = useState(false);

    const NEW_SERVICE_PROVIDER_OPTION = {
        id: "new-service-provider",
        name: "+ New Account",
        type: "new",
    };


    const fetchQuotingToolDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getQuotingToolById(id);
            const quotingToolData = response.data.attributes;
            const matchedCustomer = customerOptions.find(
                (opt) =>
                    opt.name?.trim().toLowerCase() ===
                    quotingToolData.customer?.trim().toLowerCase()); setSelectedCustomer(matchedCustomer || (quotingToolData.customer ? { id: null, name: quotingToolData.customer, type: "customer" } : null)); // listede yoksa kayıttaki adı koru
            setSalesRep(Array.isArray(quotingToolData.salesRep)
                ? salesRepOptions.filter(repOption =>
                    quotingToolData.salesRep.includes(repOption.id)) : []);
            setQuoteType(quotingToolData.quoteType ?? "");
            setRoadTransportType(quotingToolData.roadTransportType ?? "");
            setShipper(quotingToolData.shipper ?? "");
            setConsignee(quotingToolData.consignee ?? "");
            setCommodity(quotingToolData.commodity ?? "");
            setGrossWeight(quotingToolData.grossWeight ?? "");
            setChargeableWeight(quotingToolData.chargeableWeight ?? "");
            setQuantity(quotingToolData.quantity ?? "");
            setQuoteNo(quotingToolData.quoteNo ?? "");
            setTransitTime(quotingToolData.transitTime ?? "");
            setOriginFreeTime(quotingToolData.originFreeTime ?? "");
            setDestinationFreeTime(quotingToolData.destinationFreeTime ?? "");
            setSelectedIncoterm(quotingToolData.incoterm ?? "");
            setSelectedStatus(quotingToolData.status ?? "");
            setSelectedService((quotingToolData.service ?? "").trim());
            const fetchedCarriers = quotingToolData.carriers?.length
                ? quotingToolData.carriers.map((carrier) => ({
                    name: carrier.name || "",
                    cost: carrier.cost || "",
                    currency: carrier.currency || "EUR",
                    sellingCarriers: carrier.sellingCarriers || "",
                    sellingCarriersRate: carrier.sellingCarriersRate || "EUR",
                    chargeType: carrier.chargeType || "",
                }))
                : [{
                    name: "",
                    cost: "",
                    currency: "EUR",
                    sellingCarriers: "",
                    sellingCarriersRate: "EUR",
                    chargeType: "",
                }];

            setCarriers(fetchedCarriers);
            const fetchedExtraCosts =
                quotingToolData.extraCosts?.length
                    ? quotingToolData.extraCosts.map((item) => ({
                        type: item.type || "",
                        amount: item.amount || "",
                        currency: item.currency || "EUR",
                        extraSelling: item.extraSelling || "",
                        extraSellingRate: item.extraSellingRate || "EUR",
                    }))
                    : [
                        {
                            type: "",
                            amount: "",
                            currency: "EUR",
                            extraSelling: "",
                            extraSellingRate: "EUR",
                        },
                    ];

            setExtraCosts(fetchedExtraCosts);
            setHasExtraCosts(!!quotingToolData.extraCosts?.length);
            setPickupLocation({
                additionalInfo: quotingToolData.pickupLocation?.additionalInfo ?? "",
                city: quotingToolData.pickupLocation?.city ?? "",
                country: quotingToolData.pickupLocation?.country ?? ""
            });
            setDeliveryLocation({
                additionalInfo: quotingToolData.deliveryLocation?.additionalInfo ?? "",
                city: quotingToolData.deliveryLocation?.city ?? "",
                country: quotingToolData.deliveryLocation?.country ?? ""
            });
            setExportLocation({
                additionalInfo: quotingToolData.exportLocation?.additionalInfo ?? "",
                country: quotingToolData.exportLocation?.country ?? ""
            });
            setImportLocation({
                additionalInfo: quotingToolData.importLocation?.additionalInfo ?? "",
                city: quotingToolData.importLocation?.city ?? "",
                country: quotingToolData.importLocation?.country ?? ""
            });

            if (quotingToolData.pickupLocation?.country) {
                setSelectedCountry({ label: quotingToolData.pickupLocation.country });
            }
            if (quotingToolData.deliveryLocation?.country) {
                setSelectedDeliveryCountry({ label: quotingToolData.deliveryLocation.country });
            }
            if (quotingToolData.importLocation?.country) {
                setSelectedImportCountry({ label: quotingToolData.importLocation.country });
            }
            if (quotingToolData.exportLocation?.country) {
                setSelectedExportCountry({ label: quotingToolData.exportLocation.country });
            }
            setEstimatedCloseDate(quotingToolData.estimatedCloseDate ? new Date(quotingToolData.estimatedCloseDate) : null);
            setQuoteDate(quotingToolData.quoteDate ? new Date(quotingToolData.quoteDate) : null);
            setFreightCost(quotingToolData.freightCost ?? "");
            setFreightCostCurrency(quotingToolData.freightCostCurrency ?? "");
            setDestinationSallingRate(quotingToolData.destinationSallingRate ?? "");
            setDestinationSallingRateCurrency(quotingToolData.destinationSallingRateCurrency ?? "");
            setOriginSallingRate(quotingToolData.originSallingRate ?? "");
            setOriginSallingRateCurrency(quotingToolData.originSallingRateCurrency ?? "");
            setSallingRate(quotingToolData.sallingRate ?? "");
            setCurrency(quotingToolData.currency ?? "");
            setDescription(quotingToolData.description ?? "");
            setIsADR(quotingToolData.adr || false);
            setImco(quotingToolData.imco || null);
            setIsOriginCustomsClearance(quotingToolData.originCustomsClearance || false);
            setOriginCost(quotingToolData.originCost ?? "");
            setOriginCurrency(quotingToolData.originCurrency || "EUR");
            setIsDestinationCustomsClearance(quotingToolData.destinationCustomsClearance || false);
            setDestinationCost(quotingToolData.destinationCost ?? "");
            setDestinationCurrency(quotingToolData.destinationCurrency || "EUR");
            setFxRates(quotingToolData.fxRates || {});
            setRoadPricingMode(quotingToolData.roadPricingMode || "ALL_IN");
            setCreatedSource(quotingToolData.createdSource || quotingToolData.source || quotingToolData.creationType || "manual");
            setPrefillRefId(quotingToolData.prefillRefId || null);
            const savedCurrency = quotingToolData.currency || "EUR";

            const hasLineSelling =
                (quotingToolData.carriers || []).some((c) => Number(c?.sellingCarriers) > 0) ||
                (quotingToolData.extraCosts || []).some((r) => Number(r?.extraSelling) > 0);

            const savedSelling = Number(quotingToolData.sallingRate || quotingToolData.sellingRate || 0);
            const mode = quotingToolData.roadPricingMode || "ALL_IN";

            setRoadPricingMode(mode);
            setEditSellingSnapshot({
                selling: Number.isFinite(savedSelling) ? savedSelling : 0,
                currency: savedCurrency,
                roadPricingMode: quotingToolData.roadPricingMode || "ALL_IN",
                hasLineSelling,
            });

            const savedSellingStr = savedSelling ? String(savedSelling) : "0";

            if (mode === "ALL_IN" && !hasLineSelling) {
                setSellingDriver("SELLING");
                setSellingRateInput(savedSellingStr);
                setMarginPercentInput("");
                setMarginUnitInput("");
            } else {
                setSellingDriver("SELLING");
                setSellingRateInput(savedSellingStr);
            }
            // yalnızca tüm alanlar hatasız yüklendiyse kaydetmeye izin ver (yarım form DB yi ezmesin)
            savedRecordRef.current = quotingToolData;
            setEditDataLoaded(true);
        } catch (error) {
            console.error("Error fetching QuotingTool details:", error);
        } finally {
            setLoading(false);
        }
    };


    const activeSellingFieldRef = useRef(null); // "PERCENT" | "UNIT" | "SELLING" | null


    useEffect(() => {
        if (!prefill) return;

        // Eğer URL’de id varsa edit modundayız → RFQ prefill ile ezme
        if (quotingToolId) return;

        // ---- Basit map (RFQ -> Road quote) ----
        // müşteri
        if (prefill.customer?.name) {
            const found = customerOptions.find(
                (c) => (c.name || "").trim().toLowerCase() === prefill.customer.name.trim().toLowerCase()
            );
            if (found) setSelectedCustomer(found);
        }

        // sales rep
        if (Array.isArray(prefill.salesRepIds) && prefill.salesRepIds.length) {
            const reps = salesRepOptions.filter((r) => prefill.salesRepIds.includes(r.id));
            setSalesRep(reps);
        }

        // incoterm
        if (prefill.incoterm) setSelectedIncoterm(prefill.incoterm);
        if (prefill.serviceMode) setSelectedService(String(prefill.serviceMode).trim());
        if (prefill.valueOfCargoUnit != null) setQuantity(prefill.valueOfCargoUnit);

        // cargo
        if (prefill.cargoDescription) setCommodity(prefill.cargoDescription);
        if (prefill.grossWeightKg) setGrossWeight(prefill.grossWeightKg);
        if (prefill.volumeCbm) {
            // RoadForm’da volume field yoksa bunu description’a ekleyebilirsin:
            // setDescription((p) => `${p || ""}\nVolume: ${prefill.volumeCbm} cbm`.trim());
        }

        // Road transport type (RFQ transportationMode -> FTL/LTL)
        const tm = String(prefill.transportationMode || "");
        if (tm === "Road FTL") setRoadTransportType("FTL");
        if (tm === "Road LTL") setRoadTransportType("LTL");


        const originCountry = prefill.originCountry || prefill.origin || "";
        const destCountry = prefill.destinationCountry || prefill.destination || "";

        const originCity = prefill.originCity || prefill.pol || "";
        const destCity = prefill.destinationCity || prefill.pod || "";

        if (originCountry) {
            setPickupLocation((p) => ({ ...p, country: originCountry }));
            setSelectedCountry({ label: originCountry });
        }

        if (originCity) {
            setPickupLocation((p) => ({ ...p, city: originCity }));
        }

        if (destCountry) {
            setDeliveryLocation((p) => ({ ...p, country: destCountry }));
            setSelectedDeliveryCountry({ label: destCountry });
        }

        if (destCity) {
            setDeliveryLocation((p) => ({ ...p, city: destCity }));
        }

        // note/special instructions
        const noteParts = [prefill.specialInstructions, prefill.note].filter(Boolean);
        if (noteParts.length) setDescription(noteParts.join("\n"));

        // quote dates (string geliyorsa Date'e çevir)
        // RFQ: etd/eta var, Road quote: estimatedCloseDate/quoteDate kullanıyor
        if (prefill.etd) {
            const d = new Date(prefill.etd);
            if (!Number.isNaN(d.getTime())) setQuoteDate(d);
        }
        if (prefill.eta) {
            const d = new Date(prefill.eta);
            if (!Number.isNaN(d.getTime())) setEstimatedCloseDate(d);
        }
    }, [prefill, quotingToolId, customerOptions, salesRepOptions]);

    useEffect(() => {
        if (!prefill) return;
        if (quotingToolId) return; // edit modunda ezme

        setCreatedSource("prefill");

        // RFQ id / ref nerede ise onu yaz
        setPrefillRefId(
            prefill?.id ||
            prefill?.rfqId ||
            prefill?.rfqNumber ||
            prefill?.prefillRefId ||
            null
        );

    }, [prefill, quotingToolId]);


    const [pickupLocation, setPickupLocation] = useState(initialAddressState);
    const [deliveryLocation, setDeliveryLocation] = useState(initialAddressState);
    const [exportLocation, setExportLocation] = useState(initialAddressState);
    const [importLocation, setImportLocation] = useState(initialAddressState);
    const [selectedImportCountry, setSelectedImportCountry] = useState(null);
    const [selectedExportCountry, setSelectedExportCountry] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [salesRep, setSalesRep] = useState([]);
    const [consignee, setConsignee] = useState("");
    const [carriers, setCarriers] = useState([{ id: 1, name: "", cost: "", currency: "EUR", sellingCarriers: "", sellingCarriersRate: "EUR", chargeType: "" }]);
    const [extraCosts, setExtraCosts] = useState([{ type: "", amount: "", currency: "EUR", extraSelling: "", extraSellingRate: "EUR", }]);
    const [commodity, setCommodity] = useState("");
    const [grossWeight, setGrossWeight] = useState("");
    const [quantity, setQuantity] = useState("");
    const [chargeableWeight, setChargeableWeight] = useState("");
    const [quoteNo, setQuoteNo] = useState("");
    const [transitTime, setTransitTime] = useState("");
    const [originFreeTime, setOriginFreeTime] = useState("");
    const [destinationFreeTime, setDestinationFreeTime] = useState("");
    const [selectedIncoterm, setSelectedIncoterm] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedService, setSelectedService] = useState("");
    const [shipper, setShipper] = useState("");
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedDeliveryCountry, setSelectedDeliveryCountry] = useState(null);
    const [estimatedCloseDate, setEstimatedCloseDate] = useState(null);
    const [quoteDate, setQuoteDate] = useState(null);
    const [quoteType, setQuoteType] = useState(null);
    const [freightCost, setFreightCost] = useState("");
    const [freightCostCurrency, setFreightCostCurrency] = useState("");
    const [originSallingRate, setOriginSallingRate] = useState("");
    const [originSallingRateCurrency, setOriginSallingRateCurrency] = useState("");
    const [destinationSallingRate, setDestinationSallingRate] = useState("");
    const [destinationSallingRateCurrency, setDestinationSallingRateCurrency] = useState("");
    const [sallingRate, setSallingRate] = useState("");
    const [currency, setCurrency] = useState("");
    const [description, setDescription] = useState("");
    const [roadTransportType, setRoadTransportType] = useState(null);
    const [isADR, setIsADR] = useState(false);
    const [imco, setImco] = useState(null);
    const [isOriginCustomsClearance, setIsOriginCustomsClearance] = useState(false);
    const [originCost, setOriginCost] = useState("");
    const [originCurrency, setOriginCurrency] = useState("");
    const [isDestinationCustomsClearance, setIsDestinationCustomsClearance] = useState(false);
    const [destinationCost, setDestinationCost] = useState("");
    const [destinationCurrency, setDestinationCurrency] = useState("");
    const [pickupCityOptions, setPickupCityOptions] = useState([]);
    const [deliveryCityOptions, setDeliveryCityOptions] = useState([]);
    const [importCityOptions, setImportCityOptions] = useState([]);
    const [pickupCityLoading, setPickupCityLoading] = useState(false);
    const [deliveryCityLoading, setDeliveryCityLoading] = useState(false);
    const [importCityLoading, setImportCityLoading] = useState(false);
    const [fxRates, setFxRates] = useState({});
    const [createdSource, setCreatedSource] = useState("manual");
    const [prefillRefId, setPrefillRefId] = useState(null);
    const [carrierModalIndex, setCarrierModalIndex] = useState(null);
    const [hasExtraCosts, setHasExtraCosts] = useState(false);
    // Air ile aynı
    const [activeSellingField, setActiveSellingField] = useState(null); // "PERCENT" | "UNIT" | "SELLING" | null
    const [hydratingFromDb, setHydratingFromDb] = useState(false);
    // driver: sadece 1 input yazılabilir
    const [sellingDriver, setSellingDriver] = useState("PERCENT"); // "PERCENT" | "UNIT" | "SELLING"
    const [marginPercentInput, setMarginPercentInput] = useState("");
    const [marginUnitInput, setMarginUnitInput] = useState("");
    const [sellingRateInput, setSellingRateInput] = useState("");
    const convertCurrency = (amount, from, to) => {
        if (!amount || !from || !to) return 0;
        if (!exchangeRates) return 0;

        const value = Number(amount);
        if (Number.isNaN(value)) return 0;

        // API base USD
        if (from === to) return value;

        const rateFrom = exchangeRates[from];
        const rateTo = exchangeRates[to];

        if (!rateFrom || !rateTo) return 0;

        // from -> EUR-> to
        const amountInUsd = from === "EUR" ? value : value / rateFrom;
        return amountInUsd * rateTo;
    };

    const handleStateChange = (setter, key, value) => {
        setter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const fetchCitiesByCountry = async (countryLabel) => {
        const country = (countryLabel || "").trim();
        const res = await CrudService.getCitiesByCountry(country);
        const raw =
            res?.data?.data ||
            res?.data?.cities ||
            res?.data?.attributes?.data ||
            res?.data ||
            [];
        const list = Array.isArray(raw) ? raw : [];
        const cities = list.map((c) => ({ label: String(c) }));
        return cities;
    };

    useEffect(() => {
        const run = async () => {
            const country = selectedCountry?.label || pickupLocation.country;
            if (!country) {
                setPickupCityOptions([]);
                return;
            }
            try {
                setPickupCityLoading(true);
                const cities = await fetchCitiesByCountry(country);
                setPickupCityOptions(cities);
            } catch (e) {
                console.error("Pickup cities fetch error:", e);
                setPickupCityOptions([]);
            } finally {
                setPickupCityLoading(false);
            }
        };
        run();
    }, [selectedCountry, pickupLocation.country]);

    useEffect(() => {
        const run = async () => {
            const country = selectedDeliveryCountry?.label || deliveryLocation.country;
            if (!country) {
                setDeliveryCityOptions([]);
                return;
            }

            try {
                setDeliveryCityLoading(true);
                const cities = await fetchCitiesByCountry(country);
                setDeliveryCityOptions(cities);
            } catch (e) {
                console.error("Delivery cities fetch error:", e);
                setDeliveryCityOptions([]);
            } finally {
                setDeliveryCityLoading(false);
            }
        };

        run();
    }, [selectedDeliveryCountry, deliveryLocation.country]);

    useEffect(() => {
        const run = async () => {
            const country = selectedImportCountry?.label || importLocation.country;
            if (!country) {
                setImportCityOptions([]);
                return;
            }

            try {
                setImportCityLoading(true);
                const cities = await fetchCitiesByCountry(country);
                setImportCityOptions(cities);
            } catch (e) {
                console.error("Import cities fetch error:", e);
                setImportCityOptions([]);
            } finally {
                setImportCityLoading(false);
            }
        };

        run();
    }, [selectedImportCountry, importLocation.country]);

    const renderCountryAutocomplete = (label, options, value, setValue, onCountrySelect) => (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option.label}
            value={value}
            isOptionEqualToValue={(option, value) =>
                option?.label === value?.label
            }
            onChange={(event, newValue) => {
                setValue(newValue);
                onCountrySelect?.(newValue);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={label}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                />
            )}
        />
    );

    const baseCurrency = carriers[0]?.currency || "EUR";

    const totalCarrierCost = carriers.reduce((total, carrier) => {
        return (
            total +
            convertCurrency(
                carrier.cost,
                carrier.currency || baseCurrency, // para birimi seçilmemiş satır 0 sayılmasın
                baseCurrency
            )
        );
    }, 0);
    const totalExtraCost = hasExtraCosts
        ? extraCosts.reduce((total, row) => {
            return (
                total +
                convertCurrency(
                    row.amount,
                    row.currency,
                    baseCurrency
                )
            );
        }, 0)
        : 0;

    const totalFreightCost = totalCarrierCost + totalExtraCost;
    const sellingCurrencySafe = currency || baseCurrency || "EUR";

    const clearLineSelling = React.useCallback(() => {
        setCarriers((prev) =>
            (prev || []).map((c) => ({
                ...c,
                sellingCarriers: "",
                sellingCarriersRate: c.sellingCarriersRate || sellingCurrencySafe,
            }))
        );

        setExtraCosts((prev) =>
            (prev || []).map((e) => ({
                ...e,
                extraSelling: "",
                extraSellingRate: e.extraSellingRate || sellingCurrencySafe,
            }))
        );
    }, [sellingCurrencySafe]);

    // =========================
    // ✅ SELLING ENGINE (ALL_IN + BREAKDOWN)
    // =========================


    const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    // --- Buying totals (selling currency cinsinden)
    const carrierBuyingInSelling = React.useMemo(() => {
        return convertCurrency(totalCarrierCost, baseCurrency, sellingCurrencySafe);
    }, [totalCarrierCost, baseCurrency, sellingCurrencySafe, exchangeRates]);

    const extraBuyingInSelling = React.useMemo(() => {
        return convertCurrency(totalExtraCost, baseCurrency, sellingCurrencySafe);
    }, [totalExtraCost, baseCurrency, sellingCurrencySafe, exchangeRates]);

    // ✅ total buying (SELLING currency)
    const buyingTotalInSelling = React.useMemo(() => {
        return toNum(carrierBuyingInSelling) + toNum(extraBuyingInSelling);
    }, [carrierBuyingInSelling, extraBuyingInSelling]);

    // --- Breakdown selling totals: carrier.selling + extra.selling toplamı
    const breakdownCarrierSellingTotal = React.useMemo(() => {
        return (carriers || []).reduce((sum, c) => {
            return (
                sum +
                convertCurrency(
                    c?.sellingCarriers || 0,
                    c?.sellingCarriersRate || sellingCurrencySafe,
                    sellingCurrencySafe
                )
            );
        }, 0);
    }, [carriers, sellingCurrencySafe, exchangeRates]);

    const breakdownExtraSellingTotal = React.useMemo(() => {
        if (!hasExtraCosts) return 0;
        return (extraCosts || []).reduce((sum, r) => {
            return (
                sum +
                convertCurrency(
                    r?.extraSelling || 0,
                    r?.extraSellingRate || sellingCurrencySafe,
                    sellingCurrencySafe
                )
            );
        }, 0);
    }, [extraCosts, hasExtraCosts, sellingCurrencySafe, exchangeRates]);

    const breakdownSellingTotal = React.useMemo(() => {
        return toNum(breakdownCarrierSellingTotal) + toNum(breakdownExtraSellingTotal);
    }, [breakdownCarrierSellingTotal, breakdownExtraSellingTotal]);

    const hasAnySellingInput = React.useMemo(() => {
        const hasCarrierSelling = (carriers || []).some((c) => Number(c?.sellingCarriers) > 0);
        const hasExtraSelling =
            hasExtraCosts && (extraCosts || []).some((r) => Number(r?.extraSelling) > 0);
        return hasCarrierSelling || hasExtraSelling;
    }, [carriers, extraCosts, hasExtraCosts]);

    const useLineSelling = roadPricingMode === "BREAKDOWN" || hasAnySellingInput;

    const safeSet = (setter, next) => {
        const v = next === null || next === undefined ? "" : String(next);
        setter((prev) => (String(prev) === v ? prev : v));
    };

    const numOrNull = (v) => {
        if (v === "" || v === null || v === undefined) return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    };

    useEffect(() => {
        // Breakdown/line-selling aktifken ALL_IN otomatik hesap devreden çıksın
        if (useLineSelling) return;

        const buying = Number(buyingTotalInSelling);
        if (!Number.isFinite(buying)) return;

        const source = activeSellingFieldRef.current || sellingDriver;

        if (source === "PERCENT") {
            const pct = numOrNull(marginPercentInput);
            if (pct === null) return;

            const unit = (buying * pct) / 100;
            const selling = buying + unit;

            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setSellingRateInput, selling.toFixed(2));
            return;
        }

        if (source === "UNIT") {
            const unit = numOrNull(marginUnitInput);
            if (unit === null) return;

            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            const selling = buying + unit;

            safeSet(setMarginPercentInput, pct.toFixed(2));
            safeSet(setSellingRateInput, selling.toFixed(2));
            return;
        }

        if (source === "SELLING") {
            const selling = numOrNull(sellingRateInput);
            if (selling === null) return;

            const unit = selling - buying;
            const pct = buying > 0 ? (unit / buying) * 100 : 0;

            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setMarginPercentInput, pct.toFixed(2));
        }
    }, [
        useLineSelling,
        buyingTotalInSelling,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
    ]);

    const sellingCalc = React.useMemo(() => {
        const buying = toNum(buyingTotalInSelling);

        // ✅ BREAKDOWN veya satırlarda selling girilmişse => selling satır toplamıdır
        if (useLineSelling) {
            const finalSelling = toNum(breakdownSellingTotal);
            const marginUnit = finalSelling - buying;
            const marginPercent = buying > 0 ? (marginUnit / buying) * 100 : 0;

            return {
                finalSelling,
                finalMarginUnit: Number.isFinite(marginUnit) ? marginUnit : 0,
                finalMarginPercent: Number.isFinite(marginPercent) ? marginPercent : 0,
            };
        }

        // ✅ ALL_IN => % / unit / selling driver total buying üzerinden çalışır
        const pct = Number(marginPercentInput);
        const unit = Number(marginUnitInput);
        const manual = Number(sellingRateInput);

        let finalSelling = buying;
        let finalMarginUnit = 0;
        let finalMarginPercent = 0;

        if (sellingDriver === "PERCENT" && marginPercentInput !== "" && !Number.isNaN(pct)) {
            finalMarginPercent = pct;
            finalMarginUnit = (buying * pct) / 100;
            finalSelling = buying + finalMarginUnit;
        } else if (sellingDriver === "UNIT" && marginUnitInput !== "" && !Number.isNaN(unit)) {
            finalMarginUnit = unit;
            finalMarginPercent = buying > 0 ? (unit / buying) * 100 : 0;
            finalSelling = buying + unit;
        } else if (sellingDriver === "SELLING" && sellingRateInput !== "" && !Number.isNaN(manual)) {
            finalSelling = manual;
            finalMarginUnit = manual - buying;
            finalMarginPercent = buying > 0 ? (finalMarginUnit / buying) * 100 : 0;
        }

        return {
            finalSelling,
            finalMarginUnit: Number.isFinite(finalMarginUnit) ? finalMarginUnit : 0,
            finalMarginPercent: Number.isFinite(finalMarginPercent) ? finalMarginPercent : 0,
        };
    }, [
        roadPricingMode,
        hasAnySellingInput,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
        buyingTotalInSelling,
        breakdownSellingTotal,
    ]);

    const sellingInputsLocked = useLineSelling; // sadece line-selling aktifken kilitle




    const submitHandler = async (e) => {
        e.preventDefault();
        if (submittingRef.current) return;
        if (quotingToolId && !editDataLoaded) {
            setErrorMessage("Quote details could not be loaded. Please reload the page before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (!selectedCustomer) {
            setErrorMessage("Please select a customer before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (!quoteType) {
            setErrorMessage("Please select a quote type (Import / Export / Domestic / Transit) before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        setErrorMessage("");
        submittingRef.current = true;
        const quotingToolData = {
            quoteType,
            roadTransportType,
            customer: selectedCustomer?.name || "Unknown Customer",
            salesRep: salesRep.map(rep => rep.id),
            shipper,
            consignee,
            commodity,
            carriers,
            grossWeight,
            quantity,
            chargeableWeight,
            quoteNo,
            pickupLocation: { ...pickupLocation },
            deliveryLocation: { ...deliveryLocation },
            exportLocation: { ...exportLocation },
            importLocation: { ...importLocation },
            estimatedCloseDate,
            quoteDate,
            incoterm: selectedIncoterm,
            status: selectedStatus,
            service: selectedService,
            transitTime,
            originFreeTime,
            destinationFreeTime,
            adr: isADR,
            imco: imco || "",
            originCustomsClearance: isOriginCustomsClearance,
            originCost: isOriginCustomsClearance ? originCost : null,
            originCurrency: isOriginCustomsClearance ? originCurrency : null,
            destinationCustomsClearance: isDestinationCustomsClearance,
            destinationCost: isDestinationCustomsClearance ? destinationCost : null,
            destinationCurrency: isDestinationCustomsClearance ? destinationCurrency : null,
            totalCarrierCost,
            totalExtraCost,
            totalFreightCost,
            baseCurrency,
            freightCostCurrency: carriers.length > 0 ? carriers[0].currency : "EUR",
            extraCosts: hasExtraCosts ? extraCosts : [],
            destinationSallingRate,
            destinationSallingRateCurrency,
            originSallingRate,
            originSallingRateCurrency,
            description,
            selectedTransportType,
            sallingRate: Number(sellingCalc.finalSelling) || 0,
            currency: sellingCurrencySafe,
            totalCarrierSelling: Number(breakdownCarrierSellingTotal) || 0,
            totalExtraSelling: Number(breakdownExtraSellingTotal) || 0,
            roadPricingMode,
            createdSource,
            prefillRefId,
        };
        // Fiyat girdileri değişmediyse kayıtlı fiyat/marj/toplamlar korunur (kur veya kural farkı fiyatı değiştirmesin)
        if (isEditing) keepSavedPricingIfUntouched(quotingToolData, savedRecordRef.current, useLineSelling);
        try {
            setLoading(true);
            let response;
            if (isEditing) {
                response = await CrudService.updateQuotingTool(quotingToolData, quotingToolId);
                setSuccessMessage("Update operation was successfully completed.");
            } else {
                response = await CrudService.createQuotingTool({
                    data: quotingToolData,
                });
                const newQuoteNo = response.data?.data?.attributes?.quoteNo;
                if (newQuoteNo) {
                    setQuoteNo(newQuoteNo);
                }
                setSuccessMessage("Create operation was successfully completed.");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            redirectTimerRef.current = setTimeout(() => {
                navigate("/quoting-tool/quoting-tool-tables/details");
            }, 3000);
        } catch (err) {
            console.error("Request failed: ", err);
            submittingRef.current = false;
            setErrorMessage(err?.errors?.[0]?.detail || err?.message || "Save failed. Please try again.");
            window.scrollTo({ top: 0, behavior: "smooth" });
        } finally {
            setLoading(false);
        }
    };

    // Teklif numarasını kayıt sırasında backend verir (yeni teklifte alan "Auto-generated" gösterir)

    const handleSwitchChangeQuotingType = (type) => { setQuoteType((prevType) => (prevType === type ? "" : type)); };
    const handleSwitchChangeTransportType = (type) => { setRoadTransportType((prevType) => (prevType === type ? "" : type)); };

    const handleSwitchChange = () => {
        setIsADR(!isADR);
        if (isADR) {
            setImco(null);
        }
    };

    const handleIMCOChange = (event, newValue) => { setImco(newValue ? newValue.label : null); };
    const addCarrier = () => { setCarriers([...carriers, { id: carriers.length + 1, name: "", cost: "", currency: "EUR", sellingCarriers: "", sellingCarriersRate: "EUR", chargeType: "" }]); };
    const removeCarrier = (index) => { const updatedCarriers = carriers.filter((_, i) => i !== index); setCarriers(updatedCarriers); };
    const handleCarrierChange = (index, field, value) => { const updatedCarriers = carriers.map((carrier, i) => i === index ? { ...carrier, [field]: value } : carrier); setCarriers(updatedCarriers); };

    const addExtraCost = () => {
        setExtraCosts([
            ...extraCosts,
            {
                type: "",
                amount: "",
                currency: "EUR",
                extraSelling: "",
                extraSellingRate: "EUR",
            },
        ]);
    };

    const removeExtraCost = (index) => {
        setExtraCosts(extraCosts.filter((_, i) => i !== index));
    };

    const handleExtraCostChange = (index, field, value) => {
        setExtraCosts(
            extraCosts.map((row, i) =>
                i === index ? { ...row, [field]: value } : row
            )
        );
    };

    useEffect(() => {
        const fetchServiceProviders = async () => {
            try {
                const response = await CrudService.getServiceProviders();
                const options = (response.data ?? []).map((item) => ({
                    id: item.id,
                    name: item.attributes?.name || "Unnamed Service Provider",
                    type: "serviceProvider",
                }));

                setCarrierOptions(options);
            } catch (error) {
                console.error("Service Provider verileri alınırken hata oluştu:", error);
                setCarrierOptions([]);
            }
        };
        fetchServiceProviders();
    }, []);

    const handleServiceProviderCreatedFromModal = (createdProvider) => {
        const attr = createdProvider?.attributes || createdProvider;

        const newOption = {
            id: createdProvider?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Service Provider",
            type: "serviceProvider",
        };

        setCarrierOptions((prev) => {
            const exists = prev.some(
                (x) => x.name.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        setCarriers((prev) => {
            const copy = [...prev];
            copy[carrierModalIndex] = {
                ...copy[carrierModalIndex],
                name: newOption.name,
            };
            return copy;
        });

        setServiceProviderModalOpen(false);
    };

    const toEnglishAscii = (val = "") => {
        const s = String(val);
        const trMap = { "ş": "s", "Ş": "S", "ğ": "g", "Ğ": "G", "ı": "i", "I": "I", "İ": "I", "ö": "o", "Ö": "O", "ü": "u", "Ü": "U", "ç": "c", "Ç": "C", };
        const replaced = s.replace(/[şŞğĞıİöÖüÜçÇ]/g, (ch) => trMap[ch] || ch);
        const noDiacritics = replaced.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return noDiacritics.replace(/[^a-zA-Z0-9 .,\-_/()]/g, "");
    };
    const inputStyle = { "& .MuiOutlinedInput-input": { padding: "10 14px" }, };


    useEffect(() => {
        if (selectedCustomer) {
            setInputValue(selectedCustomer.name || "");
            setOpen(false); // 🔥 her set’te kapat
        }
    }, [selectedCustomer]);


    useEffect(() => {
        if (useLineSelling) return;

        const buying = toNum(buyingTotalInSelling);
        if (!Number.isFinite(buying)) return;

        const safeSet = (setter, next) => {
            const n = next == null ? "" : String(next);
            setter((prev) => (String(prev) === n ? prev : n));
        };

        const source = activeSellingFieldRef.current || sellingDriver;

        if (source === "PERCENT") {
            if (marginPercentInput === "") return; // ✅ diğerlerini SİLME
            const pct = Number(marginPercentInput);
            if (Number.isNaN(pct)) return;

            const unit = (buying * pct) / 100;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "UNIT") {
            if (marginUnitInput === "") return; // ✅ diğerlerini SİLME
            const unit = Number(marginUnitInput);
            if (Number.isNaN(unit)) return;

            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginPercentInput, pct.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "SELLING") {
            if (sellingRateInput === "") return; // ✅ diğerlerini SİLME
            const manual = Number(sellingRateInput);
            if (Number.isNaN(manual)) return;

            const unit = manual - buying;
            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setMarginPercentInput, pct.toFixed(2));
        }
    }, [
        useLineSelling,
        buyingTotalInSelling,
        activeSellingFieldRef,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
    ]);

    useEffect(() => {
        if (!useLineSelling) return;

        // user şu an bu alanlarda yazıyorsa ezme
        if (activeSellingFieldRef.current) return;

        const buying = toNum(buyingTotalInSelling);
        const selling = toNum(breakdownSellingTotal);

        const unit = selling - buying;
        const pct = buying > 0 ? (unit / buying) * 100 : 0;

        const safeSet = (setter, next) => {
            const v = next == null ? "" : String(next);
            setter((prev) => (String(prev) === v ? prev : v));
        };

        safeSet(setSellingRateInput, selling.toFixed(2));
        safeSet(setMarginUnitInput, unit.toFixed(2));
        safeSet(setMarginPercentInput, pct.toFixed(2));

        // line selling aktifken manual override kapalı kalsın
        setSellingDriver("SELLING");
    }, [
        useLineSelling,
        activeSellingFieldRef,
        breakdownSellingTotal,
        buyingTotalInSelling,
    ]);


    // Düzenlenecek kaydı müşteri/temsilci listeleri yüklendikten sonra yalnızca bir kez çek.
    // Liste sonradan değişirse (ör. modal ile yeni müşteri eklenince) kullanıcının
    // kaydedilmemiş değişiklikleri DB verisiyle ezilmesin.
    useEffect(() => {
        if (!quotingToolId) return;
        setIsEditing(true);
        if (!customersLoaded || !salesRepsLoaded) return;
        if (editFetchStartedRef.current) return;
        editFetchStartedRef.current = true;
        setManualSellingOverride(false);
        fetchQuotingToolDetails(quotingToolId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quotingToolId, customersLoaded, salesRepsLoaded]);


    useEffect(() => {
        if (hydratingFromDb) return;
        if (useLineSelling) return;

        const buying = toNum(buyingTotalInSelling);
        if (!Number.isFinite(buying)) return;

        const safeSet = (setter, next) => {
            const n = next == null ? "" : String(next);
            setter((prev) => (String(prev) === n ? prev : n));
        };

        const source = activeSellingField || sellingDriver;

        if (source === "PERCENT") {
            if (marginPercentInput === "") return;
            const pct = Number(marginPercentInput);
            if (Number.isNaN(pct)) return;

            const unit = (buying * pct) / 100;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "UNIT") {
            if (marginUnitInput === "") return;
            const unit = Number(marginUnitInput);
            if (Number.isNaN(unit)) return;

            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginPercentInput, pct.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "SELLING") {
            if (sellingRateInput === "") return;
            const manual = Number(sellingRateInput);
            if (Number.isNaN(manual)) return;

            const unit = manual - buying;
            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setMarginPercentInput, pct.toFixed(2));
        }
    }, [
        hydratingFromDb,
        useLineSelling,
        buyingTotalInSelling,
        activeSellingField,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
    ]);

    useEffect(() => {
        if (hydratingFromDb) return;
        if (!useLineSelling) return;
        if (activeSellingField) return;

        const buying = toNum(buyingTotalInSelling);
        const selling = toNum(breakdownSellingTotal);

        const unit = selling - buying;
        const pct = buying > 0 ? (unit / buying) * 100 : 0;

        const safeSet = (setter, next) => {
            const v = next == null ? "" : String(next);
            setter((prev) => (String(prev) === v ? prev : v));
        };

        safeSet(setSellingRateInput, selling.toFixed(2));
        safeSet(setMarginUnitInput, unit.toFixed(2));
        safeSet(setMarginPercentInput, pct.toFixed(2));

        setSellingDriver("SELLING");
    }, [
        hydratingFromDb,
        useLineSelling,
        activeSellingField,
        breakdownSellingTotal,
        buyingTotalInSelling,
    ]);

    return (
        <Grid container spacing={0} justifyContent="center" mt={1} mb={1}>
            <Grid item xs={12} lg={10}>
                <MDBox mb={2}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox mb={1} textAlign="center">
                                <div
                                    ref={successMessageRef}
                                    style={{
                                        backgroundColor: successMessage ? "#7edd82" : errorMessage ? "#e57373" : "transparent",
                                        color: successMessage || errorMessage ? "#FFFFFF" : "transparent",
                                        padding: "10px",
                                        textAlign: "center",
                                        marginBottom: "10px",
                                        borderRadius: "5px",
                                        visibility: successMessage || errorMessage ? "visible" : "hidden"
                                    }}
                                >
                                    {successMessage || errorMessage}
                                </div>
                                {isEditing && editDataLoaded && savedPricingNotice(savedRecordRef.current, sellingCalc.finalSelling) && (
                                    <div
                                        style={{
                                            backgroundColor: "#fff3cd",
                                            color: "#664d03",
                                            padding: "10px",
                                            textAlign: "center",
                                            marginBottom: "10px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        {savedPricingNotice(savedRecordRef.current, sellingCalc.finalSelling)}
                                    </div>
                                )}
                                <MDBox mb={1}>
                                    <MDTypography variant="h3" fontWeight="bold">
                                        {isEditing
                                            ? " Edit ROAD & Intermodal Quote Details"
                                            : " Add ROAD & Intermodal Quote Details"}
                                    </MDTypography>
                                </MDBox>
                                <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                    This information will give you more information about the Quote for ROAD &
                                    Intermodal. </MDTypography>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox mt={3}
                    sx={{
                        p: 3,
                        borderRadius: "10px",
                        bgcolor: "background.paper",
                        boxShadow: "none",
                    }}>

                    <MDBox mb={12}>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDBox mt={3}>
                                        <Grid container spacing={3} alignItems="center">
                                            <Grid item xs={6}>
                                                <MDTypography variant="h6" component="div">
                                                    Quote - ROAD & Intermodal {quoteNo}
                                                </MDTypography>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <Box
                                        mt={3}
                                        display="flex"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        gap={4}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Import"}
                                                    onChange={() => handleSwitchChangeQuotingType("Import")}
                                                    name="importSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Import" ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Import" ? "orange" : "white",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Import"
                                            sx={{ color: "gray" }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Export"}
                                                    onChange={() => handleSwitchChangeQuotingType("Export")}
                                                    name="exportSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Export" ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Export" ? "orange" : "white",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Export"
                                            sx={{ color: "gray" }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Domestic"}
                                                    onChange={() => handleSwitchChangeQuotingType("Domestic")}
                                                    name="domesticSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Domestic" ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Domestic" ? "orange" : "white",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Domestic"
                                            sx={{ color: "gray" }}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Transit"}
                                                    onChange={() => handleSwitchChangeQuotingType("Transit")}
                                                    name="transitSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Transit" ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Transit" ? "orange" : "white",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Transit"
                                            sx={{ color: "gray" }}
                                        />


                                        {/* FTL Switch */}
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={roadTransportType === "FTL"}
                                                    onChange={() => handleSwitchChangeTransportType("FTL")}
                                                    name="ftlSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: roadTransportType === "FTL" ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: roadTransportType === "FTL" ? "#FFECB3" : "#E0E0E0",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="FTL"
                                            sx={{ color: "gray", ml: 10 }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={roadTransportType === "LTL"}
                                                    onChange={() => handleSwitchChangeTransportType("LTL")}
                                                    name="ltlSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: roadTransportType === "LTL" ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: roadTransportType === "LTL" ? "#FFECB3" : "#E0E0E0",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="LTL"
                                            sx={{ color: "gray" }}
                                        />


                                    </Box>
                                    <MDBox mt={3}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="text"
                                                    label="Quote No"
                                                    value={quoteNo}
                                                    placeholder="Auto-generated"
                                                    disabled
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "" || Number(value) >= 0) setQuoteNo(value);
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="text"
                                                    label="Transport Type"
                                                    value={selectedTransportType}
                                                    disabled
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Quote Date"
                                                        value={quoteDate}
                                                        onChange={(newValue) => setQuoteDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: {
                                                                    "& .MuiInputBase-root": { height: 40, padding: "0 !important" },
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    value={selectedCustomer}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("customer");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setSelectedCustomer(newValue);
                                                        setOpen(false);
                                                    }}
                                                    inputValue={inputValue}
                                                    onInputChange={(event, newInputValue) => {
                                                        setInputValue(newInputValue);
                                                        setOpen(newInputValue.length > 0);
                                                    }}
                                                    options={[
                                                        NEW_PARTY_OPTION,
                                                        ...partyOptions,
                                                        // listede olmayan (silinmiş / adı değişmiş) kayıtlı müşteri de seçili görünsün
                                                        ...(selectedCustomer?.name && !partyOptions.some((o) => o.name === selectedCustomer.name) ? [selectedCustomer] : []),
                                                    ]}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    filterOptions={(options, state) =>
                                                        options.filter((option) =>
                                                            (option.name || "").toLowerCase().includes(state.inputValue.toLowerCase())
                                                        )
                                                    }
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={`${option.type}-${option.id}`}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>
                                                                    + New Account
                                                                </strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                        {option.type === "customer"
                                                                            ? "(Customer)"
                                                                            : "(Global Agent)"}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    open={open}
                                                    onClose={() => setOpen(false)}
                                                    onFocus={() => {
                                                        if (!isEditing) setOpen(true);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Search Customer / Global Agent"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                "& .MuiInputBase-root": { height: 50 },
                                                            }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                            }}
                                                        />
                                                    )}
                                                />

                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                                                    value={findOptionByName(shipper)}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("shipper");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setShipper(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={`${option.type}-${option.id}`}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>
                                                                    + New Account
                                                                </strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                        {option.type === "customer"
                                                                            ? "(Customer)"
                                                                            : option.type === "agent"
                                                                                ? "(Global Agent)"
                                                                                : "(Company)"}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Shipper"
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                                                    value={findOptionByName(consignee)}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("consignee");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setConsignee(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={`${option.type}-${option.id}`}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>
                                                                    + New Account
                                                                </strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                        {option.type === "customer"
                                                                            ? "(Customer)"
                                                                            : option.type === "agent"
                                                                                ? "(Global Agent)"
                                                                                : "(Company)"}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Consignee"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <Autocomplete
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesRep}
                                                    onChange={(event, newValues) => setSalesRep(newValues)}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Sales Representatives"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Cargo Details</MDTypography>
                                        </MDBox>
                                        <Grid container spacing={3} mt={1}>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="text"
                                                    label="Commodity"
                                                    value={commodity}
                                                    onChange={(e) => setCommodity(toEnglishAscii(e.target.value))}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label="Gross Weight (kg)"
                                                    value={grossWeight}
                                                    onChange={(e) => setGrossWeight(e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label="Chargeable Weight (kg)"
                                                    value={chargeableWeight}
                                                    onChange={(e) => setChargeableWeight(e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={1}>
                                                <TextField
                                                    type="number"
                                                    label="Quantity"
                                                    value={quantity}
                                                    onChange={(e) => setQuantity(e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={isADR}
                                                            onChange={handleSwitchChange}
                                                            sx={{
                                                                "& .MuiSwitch-thumb": { backgroundColor: isADR ? "orange" : "white" },
                                                                "& .MuiSwitch-track": { backgroundColor: isADR ? "orange" : "white" },
                                                            }} />}
                                                    label="ADR/DG"
                                                    sx={{ color: "gray" }}
                                                />
                                            </Grid>
                                            {isADR && (
                                                <Grid item xs={3}>
                                                    <Autocomplete
                                                        options={imcoOptions}
                                                        getOptionLabel={(option) => option.label}
                                                        value={imcoOptions.find((option) => option.label === imco) || null}
                                                        onChange={handleIMCOChange}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="IMCO Class"
                                                                variant="outlined"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiInputBase-root": { height: 40 }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid container alignItems="center" spacing={3} mt={1}>

                                        </Grid>
                                    </MDBox>



                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Service Details</MDTypography>
                                    </MDBox>
                                    <Grid container spacing={2} alignItems="center" mt={1}>
                                        {/* Estimated Close Date */}
                                        <Grid item xs={12} sm={2}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Estimated Close Date"
                                                    value={estimatedCloseDate}
                                                    onChange={(newValue) => setEstimatedCloseDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            InputLabelProps: { shrink: true },
                                                            sx: {
                                                                "& .MuiInputBase-root": { height: 40 },
                                                            },
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Transit Time */}
                                        <Grid item xs={12} sm={2}>
                                            <TextField
                                                fullWidth
                                                label="Estimated Transit Time (Days)"
                                                value={transitTime}
                                                onChange={(e) => setTransitTime(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>

                                        {/* Origin Free Time */}
                                        <Grid item xs={12} sm={2}>
                                            <TextField
                                                fullWidth
                                                label="Origin Free Time (Hours)"
                                                value={originFreeTime}
                                                onChange={(e) => setOriginFreeTime(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>

                                        {/* Destination Free Time */}
                                        <Grid item xs={12} sm={2}>
                                            <TextField
                                                fullWidth
                                                label="Destination Free Time (Hours)"
                                                value={destinationFreeTime}
                                                onChange={(e) => setDestinationFreeTime(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>

                                        {/* Incoterm */}
                                        <Grid item xs={12} sm={2}>
                                            <Autocomplete
                                                options={incotermsOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedIncoterm ? { label: selectedIncoterm } : null}
                                                onChange={(e, v) => setSelectedIncoterm(v ? v.label : "")}
                                                isOptionEqualToValue={(o, v) => o.label === v.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Incoterm"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Service Level */}
                                        <Grid item xs={12} sm={2}>
                                            <Autocomplete
                                                options={serviceOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedService ? { label: selectedService } : null}
                                                onChange={(e, v) => setSelectedService(v ? v.label : "")}
                                                isOptionEqualToValue={(o, v) => o.label === v.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Service Level"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Pickup Location</MDTypography>
                                    </MDBox>
                                    <Grid item mt={1} xs={12}>
                                        <TextField
                                            type="text"
                                            label="Additional Pickup Address Info"
                                            value={pickupLocation.additionalInfo}
                                            onChange={(e) => handleStateChange(setPickupLocation, "additionalInfo", e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                        />
                                    </Grid>
                                    <MDBox mt={2}>
                                        <Grid container spacing={3}>
                                            {/* COUNTRY SELECT */}
                                            <Grid item xs={12} sm={6}>
                                                {renderCountryAutocomplete(
                                                    "Select Pickup Country",
                                                    countryOptions,
                                                    selectedCountry,
                                                    setSelectedCountry,
                                                    (newValue) => {
                                                        handleStateChange(setPickupLocation, "country", newValue?.label || "");
                                                        handleStateChange(setPickupLocation, "city", "");
                                                    }
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Autocomplete
                                                    options={pickupCityOptions}
                                                    loading={pickupCityLoading}
                                                    value={pickupLocation.city ? { label: pickupLocation.city } : null}
                                                    isOptionEqualToValue={(o, val) => (o?.label || "") === (val?.label || "")}
                                                    onChange={(_, v) => handleStateChange(setPickupLocation, "city", v?.label || "")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="City"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Delivery Location</MDTypography>
                                    </MDBox>
                                    <MDBox mt={2}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="Additional Delivery Address Info"
                                                    value={deliveryLocation.additionalInfo}
                                                    onChange={(e) =>
                                                        handleStateChange(
                                                            setDeliveryLocation,
                                                            "additionalInfo",
                                                            e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                {renderCountryAutocomplete(
                                                    "Select Delivery Country",
                                                    countryOptions,
                                                    selectedDeliveryCountry,
                                                    setSelectedDeliveryCountry,
                                                    (newValue) => {
                                                        handleStateChange(setDeliveryLocation, "country", newValue?.label || "");
                                                        handleStateChange(setDeliveryLocation, "city", "");
                                                    }
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Autocomplete
                                                    options={deliveryCityOptions}
                                                    loading={deliveryCityLoading}
                                                    value={deliveryLocation.city ? { label: deliveryLocation.city } : null}
                                                    isOptionEqualToValue={(o, val) => (o?.label || "") === (val?.label || "")}
                                                    onChange={(_, v) => handleStateChange(setDeliveryLocation, "city", v?.label || "")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="City"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Exit Customs Location</MDTypography>
                                    </MDBox>
                                    <MDBox mt={2}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                {renderCountryAutocomplete(
                                                    "Export Country",
                                                    countryOptions,
                                                    selectedExportCountry,
                                                    setSelectedExportCountry,
                                                    (newValue) => {
                                                        handleStateChange(setExportLocation, "country", newValue?.label || "");
                                                    })}
                                            </Grid>
                                            <Grid item xs={6}>
                                                {/* Gümrük noktası elle yazılır (hazır liste kaldırıldı) */}
                                                <TextField
                                                    label="Export Exit Customs"
                                                    placeholder="Enter customs point"
                                                    value={exportLocation.additionalInfo || ""}
                                                    onChange={(e) =>
                                                        handleStateChange(setExportLocation, "additionalInfo", e.target.value)
                                                    }
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>


                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Arrival Customs Location</MDTypography>
                                    </MDBox>
                                    <MDBox mt={2}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                {renderCountryAutocomplete(
                                                    "Import Country",
                                                    countryOptions,
                                                    selectedImportCountry,
                                                    setSelectedImportCountry,
                                                    (newValue) => {
                                                        handleStateChange(setImportLocation, "country", newValue?.label || "");
                                                        handleStateChange(setImportLocation, "city", "");
                                                    })}
                                            </Grid>
                                            <Grid item xs={6}>
                                                {/* Gümrük noktası elle yazılır (hazır liste kaldırıldı) */}
                                                <TextField
                                                    label="Import Arrival Customs"
                                                    placeholder="Enter customs point"
                                                    value={importLocation.additionalInfo || ""}
                                                    onChange={(e) =>
                                                        handleStateChange(setImportLocation, "additionalInfo", e.target.value)
                                                    }
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={2}>
                                        <MDTypography variant="h6">Carriers & Freight Costs</MDTypography>
                                        {/* 🔥 ALL-IN / BREAKDOWN */}
                                        <Box display="flex" gap={3} mt={1}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={roadPricingMode === "ALL_IN"}
                                                        onChange={() => setRoadPricingMode("ALL_IN")}
                                                        sx={{
                                                            "& .MuiSwitch-thumb": {
                                                                backgroundColor: roadPricingMode === "ALL_IN" ? "orange" : "white",
                                                            },
                                                            "& .MuiSwitch-track": {
                                                                backgroundColor: roadPricingMode === "ALL_IN" ? "orange" : "white",
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="All-in"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={roadPricingMode === "BREAKDOWN"}
                                                        onChange={() => setRoadPricingMode("BREAKDOWN")}
                                                        sx={{
                                                            "& .MuiSwitch-thumb": {
                                                                backgroundColor: roadPricingMode === "BREAKDOWN" ? "orange" : "white",
                                                            },
                                                            "& .MuiSwitch-track": {
                                                                backgroundColor: roadPricingMode === "BREAKDOWN" ? "orange" : "white",
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="Breakdown"
                                            />
                                        </Box>
                                        {carriers.map((carrier, index) => (
                                            <Grid container spacing={2} alignItems="center" key={index} mt={1}>
                                                <Grid item xs={3}>
                                                    <Autocomplete
                                                        options={[NEW_SERVICE_PROVIDER_OPTION, ...carrierOptions]}
                                                        value={
                                                            carrierOptions.find(
                                                                (x) => x.name === carriers[index]?.name
                                                            ) ||
                                                            (carriers[index]?.name
                                                                ? {
                                                                    id: `manual-${carriers[index].name}`,
                                                                    name: carriers[index].name,
                                                                    type: "manual",
                                                                }
                                                                : null)
                                                        }
                                                        getOptionLabel={(option) => option?.name || ""}
                                                        isOptionEqualToValue={(a, b) => a.id === b.id}
                                                        onChange={(e, newValue) => {
                                                            if (newValue?.type === "new") {
                                                                setCarrierModalIndex(index);
                                                                setServiceProviderModalOpen(true);
                                                                return;
                                                            }

                                                            handleCarrierChange(index, "name", newValue?.name || "");
                                                        }}
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li key={optionKey} {...props}>
                                                                {option.type === "new" ? (
                                                                    <strong style={{ color: "#1976d2" }}>
                                                                        + New Account
                                                                    </strong>
                                                                ) : (
                                                                    option.name
                                                                )}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Service Provider"
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiInputBase-root": {
                                                                        height: 40,
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Autocomplete
                                                        options={chargeTypeOptions}
                                                        getOptionLabel={(option) => option.label}
                                                        value={
                                                            chargeTypeOptions.find(
                                                                (o) => o.label === carrier.chargeType
                                                            ) || null
                                                        }
                                                        onChange={(_, newValue) =>
                                                            handleCarrierChange(
                                                                index,
                                                                "chargeType",
                                                                newValue?.label || ""
                                                            )
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Charge Type"
                                                                variant="outlined"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={2}>
                                                    <TextField
                                                        type="number"
                                                        label="Freight Cost"
                                                        value={carrier.cost}
                                                        onChange={(e) => handleCarrierChange(index, "cost", e.target.value)}
                                                        variant="outlined"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }} />
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <TextField
                                                        select
                                                        label="Currency"
                                                        value={carrier.currency}
                                                        onChange={(e) => handleCarrierChange(index, "currency", e.target.value)}
                                                        variant="outlined"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}>
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <TextField
                                                        type="number"
                                                        label="Selling Rate"
                                                        value={carrier.sellingCarriers}
                                                        onChange={(e) => handleCarrierChange(index, "sellingCarriers", e.target.value)}
                                                        variant="outlined"
                                                        fullWidth
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }} />
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <TextField
                                                        select
                                                        label="Currency"
                                                        value={carrier.sellingCarriersRate}
                                                        onChange={(e) => handleCarrierChange(index, "sellingCarriersRate", e.target.value)}
                                                        variant="outlined"
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}>
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={1} display="flex" alignItems="center" gap={1}>
                                                    {index > 0 && (
                                                        <RemoveRowButton onClick={() => removeCarrier(index)} tooltip="Remove carrier" />
                                                    )}

                                                    {index === carriers.length - 1 && (
                                                        <AddRowButton onClick={addCarrier} tooltip="Add carrier" />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </MDBox>


                                    <MDBox mt={3}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={hasExtraCosts}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setHasExtraCosts(checked);

                                                        // Hayır seçilirse extraCosts sıfırla
                                                        if (!checked) {
                                                            setExtraCosts([
                                                                {
                                                                    type: "",
                                                                    amount: "",
                                                                    currency: "EUR",
                                                                    extraSelling: "",
                                                                    extraSellingRate: "EUR",
                                                                },
                                                            ]);
                                                        }
                                                    }}
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: hasExtraCosts ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: hasExtraCosts ? "orange" : "white",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Extra Charges / Accessorial Costs?"
                                            sx={{ color: "gray" }}
                                        />
                                    </MDBox>

                                    {/* 🔥 SADECE EVET İSE GÖRÜNSÜN */}
                                    {hasExtraCosts && (
                                        <MDBox mt={2}>
                                            <MDTypography variant="h6">Extra Charges</MDTypography>

                                            {extraCosts.map((row, index) => (
                                                <Grid container spacing={2} alignItems="center" key={index} mt={1}>

                                                    {/* Extra Cost Type */}
                                                    <Grid item xs={3}>
                                                        <Autocomplete
                                                            options={extraCostOptions}
                                                            groupBy={(o) => o.group}
                                                            getOptionLabel={(o) => o.label}
                                                            value={extraCostOptions.find(o => o.label === row.type) || null}
                                                            onChange={(_, v) =>
                                                                handleExtraCostChange(index, "type", v?.label || "")
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Extra Cost Type"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>

                                                    {/* Cost */}
                                                    <Grid item xs={2}>
                                                        <TextField
                                                            type="number"
                                                            label="Cost"
                                                            value={row.amount ?? ""}
                                                            onChange={(e) =>
                                                                handleExtraCostChange(index, "amount", e.target.value)
                                                            }
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                    {/* Cost Currency */}
                                                    <Grid item xs={2}>
                                                        <TextField
                                                            select
                                                            label="Currency"
                                                            value={row.currency}
                                                            onChange={(e) =>
                                                                handleExtraCostChange(index, "currency", e.target.value)
                                                            }
                                                            fullWidth
                                                        >
                                                            <MenuItem value="USD">USD</MenuItem>
                                                            <MenuItem value="EUR">EUR</MenuItem>
                                                            <MenuItem value="TRY">TRY</MenuItem>
                                                            <MenuItem value="GBP">GBP</MenuItem>
                                                        </TextField>
                                                    </Grid>

                                                    {/* Extra Selling */}
                                                    <Grid item xs={2}>
                                                        <TextField
                                                            type="number"
                                                            label="Selling Rate"
                                                            value={row.extraSelling ?? ""}
                                                            onChange={(e) =>
                                                                handleExtraCostChange(index, "extraSelling", e.target.value)
                                                            }
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                    {/* Selling Currency */}
                                                    <Grid item xs={2}>
                                                        <TextField
                                                            select
                                                            label="Currency"
                                                            value={row.extraSellingRate}
                                                            onChange={(e) =>
                                                                handleExtraCostChange(index, "extraSellingRate", e.target.value)
                                                            }
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                        >
                                                            <MenuItem value="USD">USD</MenuItem>
                                                            <MenuItem value="EUR">EUR</MenuItem>
                                                            <MenuItem value="TRY">TRY</MenuItem>
                                                            <MenuItem value="GBP">GBP</MenuItem>
                                                        </TextField>
                                                    </Grid>

                                                    {/* Add / Remove */}
                                                    <Grid item xs={1} display="flex" alignItems="center" gap={1}>
                                                        {index > 0 && (
                                                            <RemoveRowButton onClick={() => removeExtraCost(index)} tooltip="Remove charge" />
                                                        )}

                                                        {index === extraCosts.length - 1 && (
                                                            <AddRowButton onClick={addExtraCost} tooltip="Add charge" />
                                                        )}
                                                    </Grid>

                                                </Grid>
                                            ))}
                                        </MDBox>
                                    )}



                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Selling Rate Details</MDTypography>

                                        <Grid container spacing={2} mt={1} alignItems="center">
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    label="Margin %"
                                                    type="number"
                                                    value={marginPercentInput}
                                                    onChange={(e) => {
                                                        setRoadPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("PERCENT");
                                                        setSellingDriver("PERCENT");
                                                        setMarginPercentInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("PERCENT")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    label={`Margin per ${sellingCurrencySafe}`}
                                                    type="number"
                                                    value={marginUnitInput}
                                                    onChange={(e) => {
                                                        setRoadPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("UNIT");
                                                        setSellingDriver("UNIT");
                                                        setMarginUnitInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("UNIT")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    label="Selling Rate"
                                                    type="number"
                                                    value={sellingRateInput}
                                                    onChange={(e) => {
                                                        setRoadPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("SELLING");
                                                        setSellingDriver("SELLING");
                                                        setSellingRateInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("SELLING")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    select
                                                    label="Currency"
                                                    value={sellingCurrencySafe}
                                                    onChange={(e) => setCurrency(e.target.value)}
                                                    fullWidth
                                                >
                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                    <MenuItem value="USD">USD</MenuItem>
                                                    <MenuItem value="TRY">TRY</MenuItem>
                                                    <MenuItem value="GBP">GBP</MenuItem>
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <MDBox
                                        mt={4}
                                        p={3}
                                        sx={{
                                            borderRadius: 2,
                                            background: "#f9f9f9",
                                            border: "1px solid #e0e0e0",
                                        }}
                                    >
                                        <Grid container spacing={3}>
                                            {/* BUYING */}
                                            <Grid item xs={12} md={6}>
                                                <MDTypography variant="body2" color="text">
                                                    Total Buying Rate
                                                </MDTypography>

                                                <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#2e7d32" }}>
                                                    {totalFreightCost.toFixed(2)}{" "}
                                                    <span style={{ fontSize: "0.7em" }}>{baseCurrency}</span>
                                                </MDTypography>

                                                {hasExtraCosts && (
                                                    <MDTypography variant="caption" color="text">
                                                        Includes Extra Costs: {totalExtraCost.toFixed(2)} {baseCurrency}
                                                    </MDTypography>
                                                )}
                                            </Grid>

                                            {/* SELLING */}
                                            <Grid item xs={12} md={6} textAlign={{ xs: "left", md: "right" }}>
                                                <MDTypography variant="body2" color="text">
                                                    Total Selling Rate
                                                </MDTypography>

                                                <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#1565c0" }}>
                                                    {Number(sellingCalc.finalSelling).toFixed(2)}{" "}
                                                    <span style={{ fontSize: "0.7em" }}>{sellingCurrencySafe}</span>
                                                </MDTypography>


                                                {hasExtraCosts && (
                                                    <MDTypography variant="caption" color="text">
                                                        Includes Extra Selling: {Number(breakdownExtraSellingTotal).toFixed(2)} {sellingCurrencySafe}
                                                    </MDTypography>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <Grid container spacing={3} mt={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                type="text"
                                                label="Description"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={3} mt={1}>
                                        <Grid item xs={12} sm={3}>
                                            <Autocomplete
                                                options={statusOptions}
                                                getOptionLabel={(o) => o.label}
                                                value={statusOptions.find((o) => o.value === selectedStatus || o.label === selectedStatus) || null}
                                                onChange={(e, newValue) => setSelectedStatus(newValue?.value || newValue?.label || "")}
                                                isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                    <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                                                        <Dot color={option.color} />{option.label}
                                                    </li>
                                                )}
                                                renderInput={(params) => {
                                                    const current =
                                                        statusOptions.find((o) => o.value === selectedStatus || o.label === selectedStatus) || null;
                                                    return (
                                                        <TextField
                                                            {...params}
                                                            label="Select Business Status"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                ...inputStyle,
                                                                "& .MuiInputBase-root": { alignItems: "center" }
                                                            }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                startAdornment: (
                                                                    <span style={{ display: "flex", alignItems: "center", marginRight: 6 }}>
                                                                        <Dot color={current?.color} />
                                                                        {params.InputProps.startAdornment}
                                                                    </span>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Grid>
                                    </Grid>

                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                    <div>
                        <form onSubmit={submitHandler}>
                            <Button
                                variant="contained"
                                onClick={submitHandler}
                                disabled={loading || !!successMessage}
                                style={{ backgroundColor: "#0B1F3A", color: "#FFFFFF" }}>
                                {isEditing ? "Update Quote" : "Create Quote"}
                            </Button>
                        </form>
                    </div>
                </MDBox>
            </Grid>
            <Dialog
                open={customerModalOpen}
                onClose={() => setCustomerModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Customer

                    <IconButton
                        onClick={() => setCustomerModalOpen(false)}
                        sx={{
                            position: "absolute",
                            right: 12,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateCustomer
                        isModal
                        onClose={() => setCustomerModalOpen(false)}
                        onCreated={handleCustomerCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={serviceProviderModalOpen}
                onClose={() => setServiceProviderModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Service Provider

                    <IconButton
                        onClick={() => setServiceProviderModalOpen(false)}
                        sx={{
                            position: "absolute",
                            right: 12,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateServiceProvider
                        isModal
                        onClose={() => setServiceProviderModalOpen(false)}
                        onCreated={handleServiceProviderCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>
        </Grid>
    );
};

export default RoadForm;
